import React from 'react';
import { arrayOf, string } from 'prop-types';

const NotFound = ({ terms, pagePath }) => (
  <div>
    <p>Couldn&apos;t find that content</p>
    <a href={pagePath}>{terms[3]}</a>
  </div>
);

NotFound.propTypes = {
  terms: arrayOf(string).isRequired,
  pagePath: string.isRequired,
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/Routes/NotFound.jsx